const useListColumns = () => {
  return [
    {
      Header: "Order",
      accessor: "order",
      disableGlobalFilter: true,
    },
    {
      Header: "Question",
      accessor: "question",
    },
    {
      Header: "Created at",
      accessor: "createDate",
      disableGlobalFilter: true,
      sortType: (rowA: any, rowB: any) => rowA.original._createDateTs - rowB.original._createDateTs,
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      disableGlobalFilter: true,
    },
  ];
};

export default useListColumns;
